import { render, staticRenderFns } from "./app-panel-request.vue?vue&type=template&id=3d86a754"
import script from "./app-panel-request.vue?vue&type=script&lang=js"
export * from "./app-panel-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports